import { defineMessages } from 'react-intl'

const scope = 'component.layouts.Header.HeaderPopover'

export default defineMessages({
  profile: {
    id: `${scope}.profile`,
    defaultMessage: 'Profile'
  }
})
